import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';

interface AccessibilityContainerProps {
  collapsedStates;
  setCollapsedStates;
  containerRef;
  onBlur;
}
const AccessibilityContainer: React.FC<AccessibilityContainerProps> = ({ ...props }) => {
  const [fontSize, setFontSize] = useState(0);
  const handleOnCollapse = position => {
    const updatedCollapsedState = props.collapsedStates.map((item, index) => (index === position ? !item : item));
    props.setCollapsedStates(updatedCollapsedState);
  };

  const onChangeFont = increment => {
    setFontSize(old => old + increment);
  };
  const mTextSizing = new TextSizing();

  return (
    <div className={`accessibility_container`}>
      <div
        className={`header brand_color ${props.collapsedStates[3] ? 'visible' : ''}`}
        onClick={e => handleOnCollapse(3)}
      >
        Accessibility
        <i className={`collapse_icon ${FontAwesomeConfigurations.ICON_MINUS} fa-fw`} />
        <i className={`expand_icon ${FontAwesomeConfigurations.ICON_CHEVRON_DOWN} fa-fw`} />
      </div>
      <motion.div
        className="dropdown_items_container"
        variants={dropdown}
        initial={`hidden`}
        animate={props.collapsedStates[3] ? 'visible' : 'hidden'}
        style={{ y: 12 }}
        ref={props.containerRef}
      >
        <div
          className="dropdown_item high_contrast_button"
          role="link"
          onClick={e => {
            Contrast.toggle();
          }}
          aria-label={CrowdHub_App.LANG.HIGH_CONTRAST}
        >
          <div className="icon large">
            <i className={FontAwesomeConfigurations.ICON_CIRCLE_HALF_STROKE}></i>
          </div>
          <div className="text">{CrowdHub_App.LANG.HIGH_CONTRAST}</div>
        </div>
        <div className="dropdown_item no_padding no_hover" role="link" aria-label="Font size controls">
          <div className="icon large">
            <i className={FontAwesomeConfigurations.ICON_TEXT_SIZE}></i>
          </div>
          <div className="text">
            <div className="sub_text">
              <div className="size_controls_container">
                <div
                  className="font_size_control_button"
                  onClick={() => {
                    mTextSizing.increaseSize(-1);
                    onChangeFont(-1);
                  }}
                  role="link"
                  aria-label="Decrease font size"
                >
                  <i className={FontAwesomeConfigurations.ICON_MINUS}></i>
                </div>
                <div className="font_size_counter" role="input" aria-label="Current font size">
                  {fontSize}
                </div>
                <div
                  className="font_size_control_button"
                  onClick={() => {
                    mTextSizing.increaseSize(1);
                    onChangeFont(1);
                  }}
                  role="link"
                  aria-label="Increase font size"
                >
                  <i className={FontAwesomeConfigurations.ICON_PLUS}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {CrowdHub_App.CONFIG.LIVE_CHAT_ENABLED && (
          <div
            className="dropdown_item"
            role="link"
            aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_HELPCHAT}
            onClick={e => {
              props.onBlur();
              App.INSTANCE.liveChat
                .createLiveChat()
                .then(() => {
                  App.INSTANCE.liveChat.showLiveChat();
                  App.INSTANCE.liveChat.showLiveChatToggle();
                })
                .catch(error => {
                  console.error('+++ Live Chat Error: ' + error);
                });
            }}
          >
            <div className="icon large">
              <i className={FontAwesomeConfigurations.ICON_CIRCLE_QUESTION}></i>
            </div>
            <div className="text">{CrowdHub_App.LANG.PROFILE_DROPDOWN_HELPCHAT}</div>
          </div>
        )}
      </motion.div>
    </div>
  );
};

const dropdown = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.15 },
    display: 'none',
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.15 },
    display: 'flex',
  },
};

export default AccessibilityContainer;
